// src/components/layout/Layout.tsx
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../common/Header';
import CategoryNav from '../common/CategoryNav';
import Footer from '../common/Footer';
import MobileTabBar from '../common/MobileTabBar';

/** 라우트 변경 시 스크롤을 맨 위로 */
const ScrollToTop: React.FC = () => {
    const { pathname, search } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname, search]);
    return null;
};

const Layout: React.FC = () => (
    <>
        <ScrollToTop />
        <Header />
        <CategoryNav />
        <main className="gh-main" id="main">
            <Outlet />
        </main>
        <Footer />
        <MobileTabBar />
    </>
);

export default Layout;
